import Barcode from 'react-barcode';
import BottomNavigationScreen from '../../Logistics/Navigation/Bottom';
import ImageUploading from 'react-images-uploading';
import { LogoutPopUp } from '../Popups';
import React, { useState } from 'react';
import {
  LogoutButtonImage,
  ForwardButtonImage,
  ProfileImage,
} from '../../../assets/Images';
import { toast } from 'material-react-toastify';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginPageStyles } from '../../../styles';
import { Box, Button, CssBaseline, Divider } from '@mui/material';
import { useAuth, useLiveFeed } from '../../../hooks';
import { Toast as CustomToast, Switch } from '../../../Components';
import {
  destroyUser,
  fetchRiderDetails,
  updateProfile,
  wazeToggle,
} from '../../../redux/features/User';
import { setCurrentTab } from '../../../redux/features/Tab';
import {
  CurrentPasswordDialog,
  ChangePasswordSuccessFullDialog,
  ChangePasswordUnsuccessfulDialog,
  ChangePasswordDialog,
} from '../Popups';

const ProfileScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);
  const [changePassword, setChangePassword] = useState(false);
  const [currentPasswordVerified, setCurrentPasswordVerified] = useState(false);
  const [hasReceived, setHasReceived] = useLiveFeed();
  const [logout, setLogout] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const [unSuccessful, setUnsuccessful] = useState(false);
  const image = user?.profile_picture_url
    ? user?.profile_picture_url
    : ProfileImage;
  const isLinkWazeEnabled = user?.enable_waze;

  useAuth(); // Authorization Hook
  useEffect(() => {
    dispatch(setCurrentTab('Profile'));
  }, []);

  const toggleLinkWaze = () => {
    const data = {
      userId: user?.id,
      isLinkWazeEnabled: isLinkWazeEnabled,
    };
    let promise = dispatch(wazeToggle(data));
    promise.unwrap().catch((err) => {
      if (err?.error === 'You need to sign in or sign up before continuing.') {
        toast(
          <CustomToast
            severity="warning"
            message="Your session has been expired"
          />,
          { closeButton: false }
        );
        dispatch(destroyUser());
        navigate('/login');
      } else {
        toast(
          <CustomToast severity="warning" message="Something went wrong" />,
          { closeButton: false }
        );
      }
    });
  };

  const onProfilePictureChange = (image) => {
    if (image?.[0]) {
      const imgType = image[0].file.type;
      const imgSize = image[0].file.size / 1000000;

      // Let's validate image before uploading
      const imgRegex = new RegExp(/[^\s]+(.*?).(jpg|jpeg|png)$/, 'i');
      if (imgRegex.test(imgType)) {
        if (imgSize > 2.0) {
          toast(
            <CustomToast
              severity="warning"
              message={'Profile picture must be less than 2MB in size'}
            />,
            {
              closeButton: false,
            }
          );
          return;
        }
      } else {
        toast(
          <CustomToast
            severity="warning"
            message={'Profile picture has an invalid content type'}
          />,
          {
            closeButton: false,
          }
        );
      }
    }

    // Now making an API CALL
    const data = {
      userId: user?.id,
      profileImage: image[0].data_url,
    };
    dispatch(updateProfile(data))
      .unwrap()
      .then(() => {
        toast(
          <CustomToast
            severity="success"
            message="Profile Image updated successfully"
          />,
          { closeButton: false }
        );
      })
      .catch((err) => {
        if (
          err?.error === 'You need to sign in or sign up before continuing.'
        ) {
          toast(
            <CustomToast
              severity="warning"
              message="Your session has been expired"
            />,
            { closeButton: false }
          );
          dispatch(destroyUser());
          navigate('/login');
        } else {
          err.errors.map((message) => {
            toast(<CustomToast severity="warning" message={message} />, {
              closeButton: false,
            });
          });
        }
      });
  };

  const handleLogout = () => {
    setLogout(true);
  };

  const changePasswordScreen = () => {
    setChangePassword(true);
  };

  // This function handles new Order Alert
  const handleNewOrderAlert = () => {
    toast(
      <CustomToast
        severity="info"
        message="New Orders Assigned. Tap to view"
        handleClick={() => navigate('/logistics')}
      />,
      {
        closeButton: false,
        autoClose: false,
      }
    );
    setHasReceived(false);
  };

  const staffTitle = {
    fontSize: '15px',
    fontWeight: '700',
    lineHeight: '20px',
    color: '#2A3752',
    fontFamily: 'Mukta',
  };
  const staffTitle2 = {
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '20px',
    color: '#455066',
    fontFamily: 'Mukta',
  };
  const staffName = {
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '31px',
    color: '#054E8B',
    fontFamily: 'Mukta',
  };
  const profileStyle = {
    fontWeight: '700',
    fontSize: '21px',
    lineHeight: '27px',
    color: '#0F2853',
    fontFamily: 'Mukta',
  };
  const staffIdStyle = {
    fontSize: '14px',
    color: '#2A3752',
    lineHeight: '19px',
    fontFamily: 'Mulish',
  };
  const staffNameStyle = {
    fontSize: '13.5px',
    color: '#8493AE',
    lineHeight: '19px',
    fontFamily: 'Mulish',
  };
  const profileTextStyle = {
    backgroundColor: '#054E8B',
    color: '#FAFAFA',
    fontWeight: '700',
    fontSize: '19px',
    lineHeight: '25px',
  };
  const profile_style = {
    fontWeight: '700',
    fontSize: '15px',
    lineHeight: '20px',
    color: '#455066',
    fontFamily: 'Mukta',
  };

  const profile_information_style = {
    display: 'flex',
    alignItems: 'baseline',
    padding: '0px 4px',
    gap: '8px',
  };

  // this useEffect is for fetching userProfile
  useEffect(() => {
    let promise = dispatch(fetchRiderDetails({ id: user?.id }));
    promise
      .unwrap()
      .then(() => {})
      .catch((err) => {
        if (
          err?.error === 'You need to sign in or sign up before continuing.'
        ) {
          toast(
            <CustomToast
              severity="warning"
              message="Your session has been expired"
            />,
            { closeButton: false }
          );
          dispatch(destroyUser());
          navigate('/login');
        }
      });
  }, []);

  const classes = loginPageStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      {hasReceived && handleNewOrderAlert()}
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box>
          {/* Profile Heading */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              my: '4px',
            }}
            style={profileStyle}
          >
            Profile
          </Box>
          {/* Profile Heading Ends here */}
          {/* User Details */}
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                padding: '8px 20px',
                gap: '20px',
                alignItems: 'center',
              }}
            >
              <Box>
                <ImageUploading
                  value={image}
                  onChange={onProfilePictureChange}
                  dataURLKey="data_url"
                >
                  {({ onImageUpload }) => (
                    <img
                      src={image}
                      alt="profile_image"
                      onClick={onImageUpload}
                      style={{
                        borderRadius: '100%',
                        width: '96px',
                        height: '96px',
                      }}
                    />
                  )}
                </ImageUploading>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '2px',
                  width: 'auto',
                }}
              >
                <Box style={staffName}>{user?.full_name}</Box>
                <Box style={profile_information_style}>
                  <Box style={staffTitle}>Staff ID</Box>
                  <Box style={staffTitle2}>{user?.staff_id}</Box>
                </Box>
                <Box style={profile_information_style}>
                  <Box style={staffTitle}>Role</Box>
                  <Box sx={{ textTransform: 'capitalize' }} style={staffTitle2}>
                    {user?.employment_type?.split('_').join(' ')}
                  </Box>
                </Box>
                <Box style={profile_information_style}>
                  <Box style={staffTitle}>Vehicle</Box>
                  <Box
                    sx={{ textTransform: 'capitalize' }}
                    className={classes.heading}
                    style={staffTitle2}
                  >
                    {user?.vehicle?.vehicle_type
                      ? user?.vehicle?.vehicle_type
                      : 'N/A'}
                  </Box>
                </Box>
                <Box style={profile_information_style}>
                  <Box style={staffTitle}>Vehicle No</Box>
                  <Box className={classes.heading} style={staffTitle2}>
                    {user?.vehicle?.number ? user?.vehicle?.number : 'N/A'}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          {/* User Details Ends here */}
        </Box>
        <Box sx={{ flex: 1 }}>
          {' '}
          {/* Profile Settings Header */}
          <Box
            sx={{
              padding: '8px 20px',
            }}
            className={classes.heading10}
            style={profileTextStyle}
          >
            Profile Settings
          </Box>
          {/* Settings Here */}
          <Box>
            <Box
              sx={{
                padding: '4px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Box style={profile_style}>Link Waze</Box>
              <Switch
                enabled={isLinkWazeEnabled}
                toggleSwitch={toggleLinkWaze}
              />
            </Box>
            <Divider />
            <Box
              onClick={changePasswordScreen}
              sx={{
                padding: '8px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Box style={profile_style}>Change Password</Box>
              <Button
                variant="text"
                sx={{
                  minWidth: '0px',
                  p: '0px',
                  ':hover': {
                    bgcolor: '#ffffff',
                    color: '#000000',
                  },
                }}
              >
                <img
                  src={ForwardButtonImage}
                  alt=""
                  style={{
                    width: '26px',
                  }}
                />
              </Button>
            </Box>
            <Divider />
            <Box
              onClick={handleLogout}
              sx={{
                padding: '8px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Box style={profile_style}>Log Out</Box>
              <Button
                variant="text"
                sx={{
                  minWidth: '0px',
                  p: '0px',
                  ':hover': {
                    bgcolor: '#ffffff',
                    color: '#000000',
                  },
                }}
              >
                <img
                  src={LogoutButtonImage}
                  alt=""
                  style={{
                    width: '25px',
                  }}
                />
              </Button>
            </Box>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                my: 'auto',
              }}
            >
              <Barcode
                value={user?.staff_id}
                background="#ffffff"
                textPosition="center"
                textAlign="center"
                fontSize={14.5}
                font="Mulish"
                displayValue={false}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexFlow: 'wrap',
                  mt: '-1px',
                }}
              >
                <Box style={staffIdStyle}>{user?.staff_id}</Box>
                <Box
                  sx={{
                    mr: '4px',
                  }}
                ></Box>
                <Box style={staffNameStyle}>{user?.full_name}</Box>
              </Box>
            </Box>
            <Box
              sx={{
                bottom: 0,
                width: '100%',
              }}
            >
              {changePassword ? (
                currentPasswordVerified ? (
                  <>
                    <ChangePasswordDialog
                      user={user?.id}
                      setChangePasswordDialog={setChangePassword}
                      setSuccessful={setSuccessful}
                      setUnsuccessful={setUnsuccessful}
                      setCurrentPasswordVerified={setCurrentPasswordVerified}
                    />
                  </>
                ) : (
                  <CurrentPasswordDialog
                    user={user?.id}
                    setChangePasswordDialog={setChangePassword}
                    setSuccessful={setSuccessful}
                    setUnsuccessful={setUnsuccessful}
                    setCurrentPasswordVerified={setCurrentPasswordVerified}
                  />
                )
              ) : null}
              {successful && <ChangePasswordSuccessFullDialog dialog={true} />}
              {unSuccessful && (
                <ChangePasswordUnsuccessfulDialog
                  setUnsuccessful={setUnsuccessful}
                  dialog={true}
                />
              )}

              {logout && <LogoutPopUp setLogout={setLogout} />}
            </Box>
          </Box>
        </Box>
        <Box>
          <BottomNavigationScreen />
        </Box>
      </Box>
    </React.Fragment>
  );
};
export default ProfileScreen;
